import { render, staticRenderFns } from "./PageStructureNew.vue?vue&type=template&id=257d251a&"
import script from "./PageStructureNew.vue?vue&type=script&lang=ts&"
export * from "./PageStructureNew.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructureNew.vue?vue&type=style&index=0&id=257d251a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports